import { useState } from "react";

type StateType = {
  bgClass: string;
  textClass: string;
  text: string;
};

export function App() {
  const [currentState, setCurrentState] = useState(0);

  // Состояния с использованием произвольных значений Tailwind
  const states: StateType[] = [
    {
      bgClass: "bg-[#ff006e]",
      textClass: "text-[#ffd60a]",
      text: "why?",
    },
    {
      bgClass: "bg-[#ffd60a]",
      textClass: "text-[#ff006e]",
      text: "are you",
    },
    {
      bgClass: "bg-[#011936]",
      textClass: "text-[#ff36ab]",
      text: "GAAAAAAY!",
    },
    {
      bgClass: "bg-[#ff36ab]",
      textClass: "text-[#011936]",
      text: "nice!!!",
    },
    {
      bgClass: "bg-[#1ed760]",
      textClass: "text-[#121212]",
      text: "spotify xD",
    },
    {
      bgClass: "bg-[#121212]",
      textClass: "text-[#1ed760]",
      text: "spotify?",
    },
    {
      bgClass: "bg-[#0a192f]",
      textClass: "text-[#ffd700]",
      text: "fuuuu!",
    },
    {
      bgClass: "bg-[#ffd700]",
      textClass: "text-[#0a192f]",
      text: "fuuuu!",
    },
    {
      bgClass: "bg-[#40ffa7]",
      textClass: "text-[#050761]",
      text: "this!!",
    },
    {
      bgClass: "bg-[#050761]",
      textClass: "text-[#40ffa7]",
      text: "is!",
    },
    {
      bgClass: "bg-[#132440]",
      textClass: "text-[#BF092F]",
      text: "barca?",
    },
    {
      bgClass: "bg-[#BF092F]",
      textClass: "text-[#132440]",
      text: "nooooo!",
    },
    {
      bgClass: "bg-[#7886C7]",
      textClass: "text-[#FFF2F2]",
      text: "soft...",
    },
    {
      bgClass: "bg-[#FFF2F2]",
      textClass: "text-[#7886C7]",
      text: "wait!!!!",
    },
    {
      bgClass: "bg-[#ffa31a]",
      textClass: "text-[#292929]",
      text: "porn!",
    },
    {
      bgClass: "bg-[#292929]",
      textClass: "text-[#ffa31a]",
      text: "hahaha!",
    },
  ];


  const handleClick = () => {
    setCurrentState((prev) => (prev + 1) % states.length);
  };

  const currentStateData = states[currentState]!;

  return (
    <div
      className={`w-screen h-screen flex flex-col items-center justify-center cursor-pointer transition-all duration-500 ease-in-out m-0 p-0 relative font-['Bebas_Neue'] ${currentStateData.bgClass}`}
      onClick={handleClick}
    >
      <>
        <h1
          className={`font-normal select-none transition-all duration-500 ease-in-out m-0 p-0 ${currentStateData.textClass}`}
          style={{
            fontSize: "clamp(4rem, 15vw, 20rem)",
          }}
        >
          {currentStateData.text}
        </h1>
      </>
    </div>
  );
}

export default App;
